// Ticking values. Each one re-renders on its own so the console does not re-render every second.

import { useNow } from '../hooks.ts';
import { fmtTime, tzAbbr } from '../time.ts';
import { dur, ms } from './util.ts';

/** Elapsed time since `from` ("02:41"); amber once `lateAt` has passed. */
export function Since({ from, lateAt, className = '', tag = 'span' }: { from: string | null; lateAt?: string | null; className?: string; tag?: 'span' | 'b' }) {
  const now = useNow(1000);
  const t = ms(from);
  const late = ms(lateAt ?? null);
  const cls = `${className}${late !== null && now > late ? ' late' : ''}`;
  const text = t === null ? '—' : dur(now - t);
  return tag === 'b' ? <b className={cls}>{text}</b> : <span className={cls}>{text}</span>;
}

/** Ticking clock in a site's time zone. */
export function SiteClock({ tz }: { tz: string }) {
  const now = useNow(1000);
  return (
    <>
      <b>{fmtTime(now, tz)}</b>
      <span className="dim mono tiny">{tzAbbr(tz, now)}</span>
    </>
  );
}
